CampagneValidator.$inject = ['validator'];

export default function CampagneValidator(validator) {
    const instance = new validator();
    instance.ruleFor('typeSaisiesId').notEmpty().withMessage('VALIDATION_NOTEMPTY');
    return instance;
}
